import { useEffect, useReducer, createContext } from 'react'

import { authReducer } from './AuthReducer'
import { IState, IAction, AuthContextType, IEntity } from './AuthInterface'
import { useAppDispatch } from '../../hooks/useReduxHooks'
import { setAuthenticated, setScheduledActive, setToken } from '../../store/slices'

const defaultEntity: IEntity = {
    _id: '',
    entity_name: '',
    description: '',
    admin: '',
    domain: '',
    user: '',
    roles: {
        counter: false,
        admin: false,
        coordinador: false,
        estudiante: false,
        docente: false,
    },
    customize: {
        logo: '/images/login/playtec.svg',
        portrait: '',
        colors: { bg_sidebar: '#197BFF', bg_buttons: '#197BFF', font_color: '#ffffff' },
    },
}

const defaultRoles = { admin: false, coordinador: false, counter: false }

const init = () => {
    const userDefaults = {
        _id: '',
        username: '',
        email: '',
        name: '',
        lastname: '',
        photo: '',
        phone: '',
        address: '',
        dni: '',
        documentType: '',
        rol: '',
    }

    try {
        const raw = localStorage.getItem('user')
        if (raw) {
            const parsed = JSON.parse(raw)
            // normalize shape with safe defaults
            parsed.user = { ...userDefaults, ...(parsed.user || {}) }
            parsed.rolesByEntity = parsed.rolesByEntity || defaultRoles
            parsed.listEntity = parsed.listEntity || []
            parsed.token = parsed.token || ''
            parsed.username = parsed.username || parsed.user.username || ''
            parsed.rol = parsed.rol || parsed.user.rol || ''
            parsed.idUser = parsed.idUser || parsed.user._id || ''
            parsed.dataEntity = { ...defaultEntity, ...(parsed.dataEntity || {}) }
            parsed.platform = parsed.platform || { id: '', platform_name: '', alias: '', description: '' }
            return parsed
        }
    } catch (e) {
        console.error('Error parsing stored user', e)
    }
    return {
        logged: false,
        user: userDefaults,
        rolesByEntity: defaultRoles,
        listEntity: [],
        token: '',
        username: '',
        rol: '',
        idUser: '',
        dataEntity: defaultEntity,
        platform: { id: '', platform_name: '', alias: '', description: '' },
    }
}

const initialState: IState = {
    user: {
        _id: '',
        username: '',
        email: '',
        name: '',
        lastname: '',
        photo: '',
        phone: '',
        address: '',
        dni: '',
        documentType: '',
        rol: '',
    },
    rolesByEntity: defaultRoles,
    listEntity: [],
    token: '',
    username: '',
    rol: '',
    main_rol: '',
    idUser: '',
    dataEntity: defaultEntity,
    platform: { id: '', platform_name: '', alias: '', description: '' },
}

export const AuthContext = createContext<AuthContextType>({
    user: initialState,
    dispatch: (() => {}) as React.Dispatch<IAction>,
})

const AuthProvider = (props: any) => {
    const [user, dispatch] = useReducer(authReducer, {} as IState, init) as [IState, React.Dispatch<IAction>]

    const dispatchRedux = useAppDispatch()

    useEffect(() => {
        user.logged
            ? localStorage.setItem('user', JSON.stringify(user))
            : localStorage.clear()
    }, [user])

    useEffect(() => {
        dispatchRedux(setToken(user.token))
        dispatchRedux(setAuthenticated(!!user.token))
    }, [user.token, dispatchRedux])

    useEffect(() => {
        console.log('init coordinator routes')
        // console.log(currentScheduled)
        const currentScheduled = localStorage.getItem('currentScheduled')
        if (currentScheduled)
            dispatchRedux(setScheduledActive(JSON.parse(currentScheduled)))
    }, [dispatchRedux])

    return (
        <AuthContext.Provider value={{ user, dispatch }}>
            {props.children}
        </AuthContext.Provider>
    )
}

export default AuthProvider
